import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Servicios from "../pages/servicios/page";
import Nosotros from "../pages/nosotros/page";
import Opiniones from "../pages/opiniones/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicios",
    element: <Servicios />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/opiniones",
    element: <Opiniones />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
